import { useState, useEffect } from "react";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPost } from "../../../api";

import MDPopup from "../../../components/MDPopup";
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import MDSelect from "../../../components/MDSelect";


const Page = (props) => {
	const { user } = useAuthContext();

	const ticket = props.ticket;

	const [cause, setCause] = useState('');
	const [action_todo, setAction_todo] = useState('');
	const [action_done, setAction_done] = useState('');

	const [action_follow_12, setAction_follow_12] = useState(null);
	const [action_follow_24, setAction_follow_24] = useState(null);

	const [validSubmit, setValidSubmit] = useState(false);

	useEffect(() => {
		setValidSubmit(!!cause && !!action_todo && !!action_done && !!action_follow_12 && !!action_follow_24);
	}, [cause, action_todo, action_done, action_follow_12, action_follow_24])

	useEffect(() => {
		setCause("");
		setAction_todo("");
		setAction_done("");

		setAction_follow_12(null);
		setAction_follow_24(null);

		setValidSubmit(false)
	}, [props.open])

	const handleSubmit = async () => {
		const response = await httpPost(process.env.REACT_APP_URL_BASE+`/correction/create`, {
              ticket_id: ticket,
              cause: cause,
              action_todo: action_todo,
              action_done: action_done,

              action_follow_12: Boolean(action_follow_12),
              action_follow_24: Boolean(action_follow_24),
            })

		if (response.status !== 201) {
            alert("Something went wrong");
            console.log(response);
            return
        }

        props.setRefreshed(true);
        props.close();
	}


	return <>
		<MDPopup display="flex" flexDirection="column" justifyContent="center" alignItems="center" open={props.open}>
	        <MDTypography variant="h3" color="info" textAlign="center" fontWeight="bold">Add Corrective Action</MDTypography>

	        <br />

	        <MDTypography variant="h5" color="dark" textAlign="center" fontWeight="bold">
	        	Document the technical fix or workaround applied to resolve this ticket.<br />This information will be stored for auditing and knowledge base improvement.
	        </MDTypography>

	        <br />
	        <MDBox width="70%">
	          <MDTypography variant="h6" color="text">Possible Cause(s) :</MDTypography>
	          <MDInput type="text" multiline rows={3} value={cause} onChange={(e) => setCause(e.target.value)} sx={{width: "100%"}} />
	        </MDBox>

	        <br />
	        <MDBox width="70%">
	          <MDTypography variant="h6" color="text">Action Taken :</MDTypography>
	          <MDInput type="text" multiline rows={3} value={action_todo} onChange={(e) => setAction_todo(e.target.value)} sx={{width: "100%"}} />
	        </MDBox>

	        <br />
	        <MDBox width="70%">
	          <MDTypography variant="h6" color="text">Corrective Action :</MDTypography>
	          <MDInput type="text" multiline rows={3} value={action_done} onChange={(e) => setAction_done(e.target.value)} sx={{width: "100%"}} />
	        </MDBox>

	        <br />
	        <MDBox width="70%">
	          <MDTypography variant="h6" color="text">Have we received the same complaint within the last 12 months ?</MDTypography>
	          
	          <MDTypography variant="label" color="text">
	          	<input type="radio" value={action_follow_12} onChange={(e) => setAction_follow_12(e.target.value)} name="follow_12" value={1} style={{margin: "0 0 0 2em"}} /> Yes
	          	<br />
	          	<input type="radio" value={action_follow_12} onChange={(e) => setAction_follow_12(e.target.value)} name="follow_12" value={0} style={{margin: "0 0 0 2em"}} /> No
	          </MDTypography>
	        </MDBox>

	        <br />
	        <MDBox width="70%">
	          <MDTypography variant="h6" color="text">Have we received the same complaint within the last 24 months ?</MDTypography>
	          
	          <MDTypography variant="label" color="text">
	          	<input type="radio" value={action_follow_24} onChange={(e) => setAction_follow_24(e.target.value)} name="follow_24" value={1} style={{margin: "0 0 0 2em"}} /> Yes
	          	<br />
	          	<input type="radio" value={action_follow_24} onChange={(e) => setAction_follow_24(e.target.value)} name="follow_24" value={0} style={{margin: "0 0 0 2em"}} /> No
	          </MDTypography>
	        </MDBox>

	        <br />

	        <MDBox width="70%" textAlign="center">
	          <MDButton onClick={handleSubmit} disabled={!validSubmit} variant="text" color="success">Evaluate</MDButton>
	          <MDButton variant="outlined" color="error" onClick={props.close}>Cancel</MDButton>
	        </MDBox>
	    </MDPopup>
	</>
}

export default Page